
import { Component, Prop, Vue } from 'vue-property-decorator';
import { WebsiteComposite } from '@/services/Website/interfaces';

@Component
export default class RecreateWebsitePanel extends Vue {
  @Prop({ type: Object, required: true })
  public composite!: WebsiteComposite;

  @Prop({ type: Boolean, default: false })
  public busy!: boolean;

  @Prop({ type: String, default: '' })
  public errorMessage!: string;

  public get domain(): string {
    return this.composite.website.domain;
  }

  public onSubmit(): void {
    this.$emit('submit', {});
  }
}
